import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { resolvePath } from 'react-router-dom';
import pages from 'pages';
import ReactModal from 'react-modal';
import { useTheme } from 'styled-components';
import { generateRandomString } from 'shared/utils';
import useUser from 'hooks/useUser';
import { VideoResourcesWrapper, VideoResourcesContainer } from './VideoResources.styles';
import { useGetVideoResources } from '../../../../api/videoResources';
import { VideoCard } from '../../components/VideoCard/VideoCard';
import { VideoResourceType } from '../../../../api/types';
import {
  ContainerClose,
  InnerContainer,
  modalStyles,
  Header as ModalHeader,
} from '../../../../shared/components/Modal/Modal.styles';
import { CloseIcon } from '../../../../shared/components/icons/CloseIcon';
import { Header } from '../../../../shared/components/Header/Header';
import { VideoPlayer } from '../../components/VideoCard/VideoPlayer';

export function VideoResources() {
  const { t } = useTranslation();
  const theme = useTheme();

  const { selectedAgreement } = useUser();
  const { data: videoResourcesData } = useGetVideoResources();

  const styles = modalStyles(theme);

  const [playingVideoResource, setPlayingVideoResource] = useState<VideoResourceType>();

  const filteredVideos = useMemo(() => {
    const agreementTags = new Set(selectedAgreement?.tags.map((tag) => tag.toLowerCase()));
    const videoResources = videoResourcesData
      ? videoResourcesData.filter(
          (item) =>
            !item.hidden &&
            item.tags.some((tagItem) => agreementTags.has(tagItem.tag.toLowerCase())),
        )
      : [];
    return videoResources.map((video) => (
      <VideoCard
        key={generateRandomString()}
        videoResourceType={video}
        onClick={() => {
          setPlayingVideoResource(video);
        }}
      />
    ));
  }, [videoResourcesData, selectedAgreement?.tags]);

  const handleRequestClose = () => {
    setPlayingVideoResource(undefined);
  };

  return (
    <VideoResourcesWrapper>
      <Header
        routeBreadCrumbs={[
          {
            label: t('support&FAQs.support&FAQs'),
            link: resolvePath(`/${pages.SUPPORT}`),
          },
          { label: t('support&FAQs.videoResources.title') },
        ]}
        pageName="VIDEO_RESOURCES"
        title={t('support&FAQs.videoResources.title')}
      />
      <ReactModal
        isOpen={!!playingVideoResource}
        style={styles}
        onRequestClose={() => {
          setPlayingVideoResource(undefined);
        }}
      >
        <InnerContainer
          $isFullWidth
          $isFullHeight
          $styleVariant="tertiary"
          $fitContent
          $padding="0"
          $maxWidth="80%"
          $maxHeight="80%"
        >
          <ModalHeader $showButton $styleVariant="tertiary" $hasSubheader={false}>
            <ContainerClose
              aria-label="Close"
              onClick={handleRequestClose}
              $showButton
              $styleVariant="tertiary"
            >
              <CloseIcon size="large" color={theme.colors.textPrimarySecondary1100} />
            </ContainerClose>
          </ModalHeader>

          <VideoPlayer url={playingVideoResource?.url} height={800} />
        </InnerContainer>
      </ReactModal>

      <VideoResourcesContainer>{filteredVideos}</VideoResourcesContainer>
    </VideoResourcesWrapper>
  );
}
export default VideoResources;
